import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router'; // import router from angular router
import { Utils } from '../common/utils.component'
import { APIService } from '../common/api.component';
import { Subject, Subscription } from 'rxjs';
import { SharedService } from '../common/shared.service';
import { ShareLink } from '../models/sharelink';
import { Constants } from '../common/constants';
import { MatDialog } from '@angular/material/dialog';
import { SortByPipe } from '../pipes/sort-by.pipe';
import { ShareUtils } from '../common/shareutils';
import { takeUntil } from "rxjs/operators";
import { APIData } from '../common/APIData';

export enum SelectionType {
  All,
  Folders,
  Files
}

@Component({
  selector: 'app-folder',
  templateUrl: './folder.component.html'
})

export class FolderComponent implements OnInit, OnDestroy {
  dataSource: any;
  clickedRow: any;
  highlightRow: FileFolderItem;
  subscription: Subscription;
  activeSort: string;
  isFilterRunning: boolean;
  isActiveTab: boolean;
  isUpload: any;
  file: any;
  siteId: number;
  loadingMessage: string;
  movetoMainPage: boolean;
  private onDestroy$: Subject<void> = new Subject<void>();
  private onFileFolderDestroy$: Subject<void> = new Subject<void>();
  siteName: any;
  FOLDERS = 1
  FILES = 2
  isShare: boolean;
  mParentFolder: any;
  siteLastModified: any;
  errorMsg = { str: "" }
  sharebutton={isDisabled:false,sharetitle:"",sharetitledefault:Constants.SHARE_LINK}
  //sharetitledefault = Constants.SHARE_LINK

  cancel = Constants.CANCEL

  constructor(
    private apiService: APIService,
    private route: Router,
    private activeRoute: ActivatedRoute,
    private utils: Utils,
    private sharedService: SharedService,
    private dialog: MatDialog,
    private sortbyPipe: SortByPipe,
    private shareUtils: ShareUtils
  ) {
    this.subscription = sharedService.searchedText$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        searchText => {
          this.clearErrorMsg()
          this.searchText = searchText;
        });

    this.subscription = sharedService.activeFilter$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        filter => {
          if (filter == "All")
            this.selectionType = SelectionType.All;
          else if (filter == "Folders")
            this.selectionType = SelectionType.Folders;
          else if (filter == "Files")
            this.selectionType = SelectionType.Files;
          this.dataSelection(this.selectionType);
        });

    this.subscription = sharedService.activeSort$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        activeSort => {
          this.activeSort = activeSort;
          this.setSortOptions(true, true)
        });

    this.subscription = sharedService.isShare$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        isShare => {
          this.isShare = isShare;
          if(!this.isShare)
             this.isParent=true;
        });

    this.subscription = sharedService.updateBreadcrumMenuSource$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        obj => {
          this.breadCrumb(obj[0], obj[1], obj[2])
        });

    this.searchText = '';
    this.clickedRow = function (item) {
      this.clearErrorMsg()
      this.highlightRow = item;
      this.isParent=false;
    }
  }

  searchText;
  offset: number = 0;
  limit: number = 100;
  folderId: number;
  isFolderCall: boolean = true;
  isFileCall: boolean = true;
  folderCount: number = 0;
  fileCount: number = 0;

  folders: FileFolderItem[];
  share = new ShareLink();
  loading: boolean = true;
  foldersArr: object[];
  siteFolderId: number;
  parentFolderId: number;
  selectionType: SelectionType;
  type: string;
  name: string;
  isButtonVisible: boolean = false;
  isParent: boolean =true;
  //sharetitle: string;

  noFilesFolders = Constants.NO_FILE_FOLDERS
  noFolders = Constants.NO_FOLDERS
  noFiles = Constants.NO_FILES
  uploadToHQ = Constants.UPLOAD_FILE_TO_HQ
  blnOverrideDuplicate: boolean = false;
  duplicateFileDetectionLevel: number = 0;

  ngOnInit() {
    this.apiService.ValidateMsTeamContextAndFatchTeamsId(this.sharedService);
    this.apiService.setTheme();
    this.sharedService.setLoading(this.loading);
    this.sharedService.setInsideFolderfiles(true);
    this.sharedService.setSeachText("")
    this.isFilterRunning = true;
    this.isActiveTab = true;
    this.sharedService.setFilter("All");
    this.isFilterRunning = false;
    if (localStorage.getItem(Constants.SHOW_DIALOG_STORAGE) === 'true'|| localStorage.getItem(Constants.SHOW_DIALOG_STORAGE) === 'undefined'|| localStorage.getItem(Constants.SHOW_DIALOG_STORAGE)==null)
      this.sharebutton.sharetitle = Constants.NEXT;
    else
      this.sharebutton.sharetitle = Constants.SHARE_LINK;

    this.selectionType = SelectionType.All;
    this.setApiCallBasedOnType(true, false);
    this.activeRoute.paramMap
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((params: ParamMap) => {
        this.siteFolderId = +params.get('folderId'); // (+) converts string 'id' to a number
        this.type = params.get('type');
        this.name = params.get('name');
        this.mParentFolder=window.history.state.parentfolder
        this.siteId = window.history.state.siteId
        this.siteName = window.history.state.siteName 
        this.siteLastModified = window.history.state.siteLastModified
        this.blnOverrideDuplicate = window.history.state.overrideDuplicate
        this.duplicateFileDetectionLevel = window.history.state.duplicateFileDetectionLevel
   
        if (window.history.state.breadCrumb != undefined) {
          this.foldersArr = window.history.state.breadCrumb
          this.foldersArr.forEach((value, index) => {
            if (this.foldersArr[index]['name'].length > 0) {
              var obj = [this.foldersArr[index]['name'], this.type]
              this.sharedService.addToBreadcrumMenu(obj);
            }
          });
        } else {
          this.foldersArr = [{ "folderId": "-1", "parentId": "-1", "name": "" }];
        }
        this.parentFolderId = window.history.state.parentFolderId
        var folderId = window.history.state.folderId
        if (folderId != undefined)
          this.siteFolderId = folderId
      });
    this.getFoldersFiles(null, this.siteFolderId, 0, this.name, true, null, window.history.state.folderId != undefined);
    this.isUpload = this.sharedService.isUploadFlow$.getValue();
    this.file = this.sharedService.uploadFile$.getValue() || {};
  }

  ngAfterViewChecked() {
    if (!this.loading)
      this.utils.setContentHeight(this.isButtonVisible, true, this.isUpload, false, false);
  }

  public dataSelection(type: SelectionType) {
    this.clearErrorMsg()
    if (!this.isFilterRunning && this.isActiveTab) {
      this.selectionType = type;
      this.loading = true;
      this.sharedService.setLoading(this.loading);
      this.resetAndCallApI();
    }
  }

  public setApiCallBasedOnType(folderCall: boolean, fileCall: boolean) {
    this.isFolderCall = (folderCall && this.selectionType != SelectionType.Files);
    this.isFileCall = (fileCall && this.selectionType != SelectionType.Folders);
  }

  public resetParameters() {
    this.offset = 0;
    this.folderCount = 0;
    this.fileCount = 0;
    this.folders = undefined;
    this.setApiCallBasedOnType(this.selectionType != SelectionType.Files, this.selectionType == SelectionType.Files);
  }

  public getFoldersFiles(item, folderId, parentId, name, isFolder, fileType, siteResFirstCall) {
    this.clearErrorMsg()
    this.name = name;

    if (fileType) {
      if (item != null)
        this.clickedRow(item);
      return;
    }

    if (item != null) {
      this.mParentFolder = item
    }
    this.loadingMessage = Constants.LOADING
    if (isFolder && !siteResFirstCall) {
      this.loading = true;
      this.sharedService.setLoading(this.loading);
      this.isButtonVisible = false;
      var obj = [this.name, this.type]
      this.sharedService.addToBreadcrumMenu(obj);
    }
    this.addFolder(folderId, parentId, name);

    if (this.folderId != folderId) {
      this.folderId = folderId;
      this.resetParameters();
    }
    if (this.isFolderCall && this.selectionType != SelectionType.Files)
      this.getFolders(folderId);
    if (this.isFileCall && this.selectionType != SelectionType.Folders) {
      if (!this.isUpload) {
        this.getFiles(folderId);
      } else {
        var response = []
        this.handleFilesResponse(response)
      }
    }
  }

  closeDialog() {
    this.shareUtils.closeMainDialog(this.apiService);
  }
  public moveToUpload() {
    this.sharedService.uploadFile$.next(null);
    this.sharedService.isUploadFlow$.next(false);
    this.closeDialog()
  }

  public getFolders(folderId) {
    this.apiService.getFolders(folderId, this.offset, this.limit, this.activeSort)
      .pipe(takeUntil(this.onFileFolderDestroy$))
      .subscribe(data => {
        var foldersdata = data['folder'];
        foldersdata = foldersdata.map(folder => ({
          ...folder,
          title: `${folder['name']}`
        }));

        if (this.isUpload) {
          foldersdata = foldersdata.filter(datas => datas['foldertype'] != 'SMART');
        }
        this.folderCount += foldersdata.length;
        if (foldersdata.length < 99) {
          this.setApiCallBasedOnType(false, this.selectionType != SelectionType.Folders);
          this.offset = 0;
        }
        else { this.offset += this.limit; }
        if (this.folders) {
          for (let item of foldersdata) {
            item.types = 'folder';
            this.folders.push(item);
          }
        }
        else {
          this.folders = foldersdata;
          this.folders.forEach(function (value) {
            value.types = 'folder';
          });

        }
        if (this.folders.length < 100 && this.selectionType != SelectionType.Folders)
          this.loadMore();
        else {
          this.setSortOptions(false, false);
          this.loading = false;
          this.sharedService.setLoading(this.loading);
          if ((this.folders.length < 100))
            this.isButtonVisible = false;
          else {
            this.isButtonVisible = true;
            this.loadingMessage = Constants.LOAD_MORE_RESULTS
          }
        }
      }, err => {
        this.handleError(folderId, err, this.FOLDERS)
      });
  }
  gatherAPIData(folderId: any): any {
    var apiData = new APIData()
    apiData.apiToCall = Constants.WS_FOLDERS
    apiData.parentFolderId = this.siteFolderId
    var arr = []
    arr.push(this.foldersArr)
    arr.push(this.siteName)
    arr.push(this.siteId)
    arr.push(folderId)
    arr.push(this.type)
    apiData.additionalData = arr
    return apiData
  }

  public getFiles(folderId) {
    this.apiService.getFiles(folderId, this.offset, this.limit, this.activeSort)
      .pipe(takeUntil(this.onFileFolderDestroy$))
      .subscribe(data => {
        this.handleFilesResponse(data['file'])
      }, err => {
        this.handleError(folderId, err, this.FILES)
      });
  }
  handleError(folderId: any, err, type) {
    if (err.refCode >= 432 && err.refCode <= 434) {
      this.apiService.getSite(this.siteId).subscribe(data => {
        this.loading = false
        this.sharedService.setLoading(this.loading);
        err.sites = this.utils.getSiteTemp(data, this.siteId)
        err.apiData = this.gatherAPIData(folderId)
        this.utils.openErrorDialog({ errorData: err }, this.dialog, item => {
          if (item) {
            if (type == this.FOLDERS) {
              this.loading = true
              this.sharedService.setLoading(this.loading);
              this.getFolders(folderId)
            } else if (type == this.FILES) {
              this.loading = true
              this.sharedService.setLoading(this.loading);
              this.getFiles(folderId)
            }
          } else {
            this.moveToRoot()
            this.sharedService.clearBreadcrumMenu(true);
          }
        })
      }, errdata => {
        this.loading = false
        this.sharedService.setLoading(this.loading);
        /*  this.utils.openErrorDialog({ errorData: errdata }, this.dialog, item => {
           // Error callback can be put here
         }) */
        this.errorMsg.str = errdata.errorMsg
      })
    } else {
      this.loading = false
      this.sharedService.setLoading(this.loading);
      /* this.utils.openErrorDialog({ errorData: err }, this.dialog, item => {
        // Error callback can be put here
      }) */
      this.errorMsg.str = err.errorMsg
    }
  }

  clearErrorMsg() {
    this.errorMsg.str = ""
  }

  handleFilesResponse(filesdata: any[]) {
    filesdata = filesdata.map(file => ({
      ...file,
      title: `${file['name']}.${file['type']}`
    }));
    this.fileCount += filesdata.length;
    if (filesdata.length < 100) {
      this.isButtonVisible = false;
      this.setApiCallBasedOnType(false, false);
    }
    else {
      this.offset += this.limit;
      this.isButtonVisible = true;
      this.loadingMessage = Constants.LOAD_MORE_RESULTS
    }
    if (this.folders) {
      for (let item of filesdata) {
        item.types = 'file';
        this.folders.push(item);
      }
    }
    else {
      this.folders = filesdata;
      this.folders.forEach(function (value) {
        value.types = 'file';
      });
    }
    this.folders = this.folders.filter(data => data.type != "placeholder")
    this.loading = false;
    this.sharedService.setLoading(this.loading);
    this.setSortOptions(false, true)
  }

  public loadMore() {
    this.clearErrorMsg()
    if (!this.isFolderCall && !this.isFileCall)
      return;
    var folder = this.getFolder(this.folderId);
    this.getFoldersFiles(null, folder['folderId'], folder['parentId'], folder, false, null, false);
  }

  public showHideLoadMore(): boolean {
    return (this.isFolderCall || this.isFileCall);
  }

  public showBackPage(folderId) {
    this.removeFolderByParentId(folderId);
    var parentFolder = this.getFolder(folderId);
    this.movetoMainPage = false;
    if (!parentFolder) {
      this.moveToRoot()
      this.movetoMainPage = true;
    }
    else {
      this.loading = true;
      this.sharedService.setLoading(this.loading);
      this.isButtonVisible = false;
      this.onFileFolderDestroy$.next();
      this.onFileFolderDestroy$ = new Subject<void>();
      this.getFoldersFiles(null, parentFolder['folderId'], parentFolder['parentId'], parentFolder['name'], false, null, false);
    }
  }
  moveToRoot() {
    if (this.type === 'Browse')
      this.showSites();
    else if (this.type === 'Recent')
      this.showRecent();
    else if (this.type === 'Favourites')
      this.showFavourites();
  }

  showSites() {
    this.route.navigate(['/sites']);
  }

  showRecent() {
    this.route.navigate(['/recent']);
  }

  showFavourites() {
    this.route.navigate(['/favourite']);
  }

  public addFolder(folderId, parentId, name) {
    var folder = this.getFolder(folderId);
    this.parentFolderId = parentId;
    if (folder)
      return;

    folder = {
      folderId: folderId,
      parentId: parentId,
      name: name
    };
    this.foldersArr.push(folder);
  }

  public removeFolder(folderId) {
    const itemToRemoveIndex = this.foldersArr.findIndex(function (item) {
      return item['folderId'] === folderId;
    });
    if (itemToRemoveIndex !== -1) {
      this.foldersArr.splice(itemToRemoveIndex, 1);
    }
  }

  public removeFolderByParentId(folderId) {
    const itemToRemoveIndex = this.foldersArr.findIndex(function (item) {
      return item['parentId'] === folderId;
    });
    if (itemToRemoveIndex !== -1) {
      this.foldersArr.splice(itemToRemoveIndex, 1);
    }
  }

  public getFolder(folderId) {
    return this.foldersArr.find(function (item) {
      return item['folderId'] === folderId;
    });
  }

  public getFileIcon(type: string) {
    return this.utils.getFileIcon(type);
  }

  groupData() {
    if (this.folders != undefined) {
      const grouped = this.utils.groupBy(this.folders, folder => folder.types);
      this.folders = grouped.get("folder");
      if (this.folders && grouped.get("file")) {
        for (let item of grouped.get("file"))
          this.folders.push(item)
      } else if (grouped.get("file")) {
        this.folders = grouped.get("file");
      }
    }
  }

  breadCrumb(menu, index, menuHeader) {
    var length = menuHeader.length;
    if (menu[index] && (length - 1 > index || index == 0)) {
      for (let i = index; i < length - 2; i++) {
        this.removeFolderByParentId(this.parentFolderId);
        var parentFolder = this.getFolder(this.parentFolderId);
        this.parentFolderId = parentFolder['parentId'];
      }
      this.showBackPage(this.parentFolderId)
    }
    this.sharedService.updateBreadcrumMenuIndex(index);
    if (index == "0")
      this.sharedService.clearBreadcrumMenu(this.movetoMainPage);
  }

  shareItem() {
    this.clearErrorMsg()
    var file
    var fileFolderobj;
    if (this.isParent) {
      if (this.mParentFolder == null || this.mParentFolder == undefined) {
        fileFolderobj = {
          filefoldername: this.siteName,
          types: 'folder',
          fileType: null,
          contentId: this.siteFolderId,
          locations: this.siteName,
          fileSize: null,
          lastmodified: this.siteLastModified,
          foldertype: 'Normal'
        }
      } else {
        file = this.mParentFolder
        fileFolderobj = {
          filefoldername: file['name'],
          types: 'folder',
          fileType: file['type'],
          contentId: file['id'],
          locations: file['location'],
          fileSize: file['size'],
          lastmodified: file['modifieddate'],
          foldertype: file['foldertype']
        }
      }

    } else {
      file = this.highlightRow
      var filefoldername;
      var types = file.types;
      if (types == 'folder' || !file.type) {
        filefoldername = file.name
      }
      else {
        filefoldername = file.name + "." + file.type;
      }

      fileFolderobj = {
        filefoldername: filefoldername,
        types: types,
        fileType: file.type,
        contentId: file.id,
        locations: file.location,
        fileSize: file.size,
        lastmodified: file.modifieddate,
        foldertype: file.foldertype
      }
    }
     
    if(fileFolderobj['types']  == 'folder'&& fileFolderobj['foldertype'] && fileFolderobj['foldertype']=='SMART'){
      this.errorMsg.str = Constants.SMART_FOLDER_SHARE_LINK;
     return;
  }
    if (localStorage.getItem(Constants.SHOW_DIALOG_STORAGE) === 'true' || localStorage.getItem(Constants.SHOW_DIALOG_STORAGE) === 'undefined'|| localStorage.getItem(Constants.SHOW_DIALOG_STORAGE)==null) {
      this.utils.openDialog(this.apiService, this.dialog, fileFolderobj, this.shareUtils, this.share, false, this.sharedService, this.errorMsg,this.sharebutton);
    } else {
      this.sharebutton.sharetitle = Constants.GENERATING_LINK
      this.sharebutton.isDisabled=true;
      if (localStorage.getItem(Constants.LINKEXPIRES_STORAGE) != null) {
        this.shareUtils.generateSharelink(fileFolderobj, this.share, this.apiService, null, this.utils, this.dialog, this.shareUtils, this.sharedService, this.errorMsg, this.sharebutton)
      } else {
        this.utils.getSettings(this.apiService, this.dialog, false, fileFolderobj, this.shareUtils, this.share, false, this.sharedService, this.errorMsg,this.sharebutton)
      }
    }
  }

  uploadItem() {
    this.clearErrorMsg()
    var file
    var location
    if (this.isParent) {
      if (this.mParentFolder == null || this.mParentFolder == undefined) {
        this.route.navigateByUrl('/upload', { state: { parentFolderId: this.siteFolderId, isShareLink: false, siteId: this.siteId, uploadPath: this.siteName,overrideDuplicate: this.blnOverrideDuplicate, duplicateFileDetectionLevel: this.duplicateFileDetectionLevel } });
      } else {
        file = this.mParentFolder
        location = `${file['location']} > ${file['name']}`
        this.route.navigateByUrl('/upload', { state: { parentFolderId: file.id, isShareLink: false, siteId: this.siteId, uploadPath: location,overrideDuplicate: this.blnOverrideDuplicate, duplicateFileDetectionLevel: this.duplicateFileDetectionLevel } });
      }

    } else {
      file = this.highlightRow
      location = `${file.location} > ${file.name}`
      this.route.navigateByUrl('/upload', { state: { parentFolderId: file.id, isShareLink: false, siteId: this.siteId, uploadPath: location,overrideDuplicate: this.blnOverrideDuplicate, duplicateFileDetectionLevel: this.duplicateFileDetectionLevel } });
    }
  }

  public ngOnDestroy(): void {
    this.isActiveTab = false;
    this.subscription.remove(this.subscription);
    this.subscription.unsubscribe();
    this.onDestroy$.next();
    this.onFileFolderDestroy$.next();
  }

  setSortOptions(issortChanged: boolean, groupData: boolean) {
    this.clearErrorMsg()
    if (this.activeSort == 'nameaz' || this.activeSort == 'nameza') {
      if (issortChanged && this.isButtonVisible)
        this.resetAndCallApI()
      else
        this.folders = this.sortbyPipe.transform(this.folders, true, this.activeSort == 'nameaz' ? 'asc' : 'desc', 'name');
    }
    else if (this.activeSort == 'dateoldnew' || this.activeSort == 'datenewold') {
      if (issortChanged && this.isButtonVisible) {
        this.resetAndCallApI()
      }
      else {
        this.folders = this.sortByDate()
        if (this.activeSort == 'datenewold') {
          this.folders = this.reverseList()
        }
      }
    } else if (this.activeSort == 'sizesl') {
      this.folders = this.sortbySizeSL();
    } else if (this.activeSort == 'sizels') {
      this.folders = this.sortbySizeLS();
    }
    if (groupData)
      this.groupData();
  }

  resetAndCallApI() {
    this.resetParameters();
    this.isButtonVisible = false;
    this.getFoldersFiles(null, this.folderId, this.parentFolderId, this.name, false, null, false);
  }

  sortByDate() {
    return this.folders.sort((a: any, b: any) =>
      new Date(a.modifieddate).getTime() - new Date(b.modifieddate).getTime()
    );
  }
  reverseList() {
    return this.folders.reverse();
  }

  sortbySizeSL() {
    return this.folders.sort((a: any, b: any) =>
      a.size - b.size
    );
  }
  sortbySizeLS() {
    return this.folders.sort((a: any, b: any) =>
      b.size - a.size
    );
  }
  getText(title, extension, isextension) {
    if (extension && isextension)
      return this.utils.getHtmlEncodeString(title) + "." + extension;
    else if (extension)
      return title + " " + extension;
    else
      return this.utils.getHtmlEncodeString(title);
  }
}

export interface FileFolderItem {
  id: number;
  name: string;
  title: string;
  types: string;
  type: string;
  size: number;
  location: string
  foldertype: string
  createddate: string;
  modifieddate: string;
  createdby: CreatedBy;
  modifiedby: CreatedBy;
}
export interface CreatedBy {
  userid: number;
  firstname: string;
  lastname: string;
  email: string;
}
